module.exports = __webpack_public_path__ + "static/media/feelingProud.f05ea713.png";